import { Plugin } from "@tiptap/pm/state";
import { Extension } from "@tiptap/core";

export const DisableDragDrop = Extension.create({
  name: "disableDragDrop",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDrop(_view, event) {
            event.preventDefault();
            return true; // returning true prevents ProseMirror from handling it
          },
          handleDOMEvents: {
            dragstart(_view, event) {
              event.preventDefault();
              return true;
            }
          }
        }
      })
    ];
  }
});
